import { getTouchEventClientX } from '../functions/getTouchEventClientX'
import { useDocumentEventListener } from './useDocumentEventListener'
import { InterfaceEvent } from '../interfaces/InterfaceEvent'

export function useInterfaceDocumentEvent(
  type: 'down' | 'move' | 'up',
  fn: (event: InterfaceEvent) => any,
  condition?: boolean,
  options?: boolean | AddEventListenerOptions,
) {
  useDocumentEventListener(
    type === 'down' ? 'mousedown' : type === 'move' ? 'mousemove' : 'mouseup',
    (event: MouseEvent) => fn({ clientX: event.clientX }),
    condition,
    options,
  )

  useDocumentEventListener(
    type === 'down' ? 'touchstart' : type === 'move' ? 'touchmove' : 'touchend',
    (event) => {
      const clientX = getTouchEventClientX(event)

      if (clientX !== null) {
        fn({ clientX })
      }
    },
    condition,
    options,
  )
}
